import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const ChitChatsCarrierInput = groupInput({
  clientId: input<string>({ validator: nonEmptyValidator }),
  apiToken: input<string>({ validator: nonEmptyValidator }),
});

export type ChitChatsCarrierValue = InputSchema.Value<
  typeof ChitChatsCarrierInput
>;

export type ChitChatsCarrierForm = InputSchema.Input<
  typeof ChitChatsCarrierInput
>;

export const ChitChatsCarrierDefault = (): ChitChatsCarrierValue => ({
  clientId: "",
  apiToken: "",
});

export const CreateChitChatsCarrierForm = memo(
  function CreateChitChatsCarrierForm({
    carrierInput,
  }: {
    carrierInput: ChitChatsCarrierForm;
  }) {
    return (
      <>
        <RedoTextInput
          label="Client ID"
          placeholder=""
          setValue={carrierInput.inputs.clientId.setValue}
          value={carrierInput.inputs.clientId.value}
        />
        <RedoTextInput
          label="API token"
          placeholder=""
          setValue={carrierInput.inputs.apiToken.setValue}
          value={carrierInput.inputs.apiToken.value}
        />
      </>
    );
  },
);
